import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="app-footer">
      <Link to="/support" className="footer-link footer-link-primary">
        Contact Us
      </Link>
      <div className="footer-secondary-links">
        <Link to="/terms" className="footer-link footer-link-secondary">
          Terms &amp; Condition
        </Link>
        <Link to="/privacy-policy" className="footer-link footer-link-secondary">
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}
